import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: 'mailto:' + _ctx.email,
    class: _normalizeClass(_ctx.classes)
  }, _toDisplayString(_ctx.email), 11, _hoisted_1))
}